/**
 * Demo 登录页 - v1 认证入口
 * 选角色 + 主体 id（由 seed 数据预置），调用 /auth/demo-login 拿 token
 */

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Role } from '@ecom/shared'
import { api, setToken } from '../api/client'

const ROLE_OPTIONS: Array<{ role: Role; label: string; merchantId: string; desc: string }> = [
  { role: Role.SELLER, label: '示例商家', merchantId: 'demo-seller-01', desc: '受托方/代销商，开服务费票' },
  { role: Role.SELLER, label: '优品电商', merchantId: 'demo-seller-02', desc: '商家2 · 日用品/食品代销' },
  { role: Role.SELLER, label: '潮玩数码', merchantId: 'demo-seller-03', desc: '商家3 · 电子产品代销' },
  { role: Role.FACTORY, label: '示例工厂', merchantId: 'demo-factory-01', desc: '委托方/货主，开商品票' },
  { role: Role.FACTORY, label: '鑫源日用品', merchantId: 'demo-factory-02', desc: '工厂2 · 日用品/厨具' },
  { role: Role.FACTORY, label: '绿源食品', merchantId: 'demo-factory-03', desc: '工厂3 · 食品/零食' },
  { role: Role.ADMIN_SUPER, label: '运营-超管', merchantId: 'demo-platform', desc: '平台运营后台全权限' },
  { role: Role.ADMIN_REVIEWER, label: '运营-审核员', merchantId: 'demo-platform', desc: '商户审核' },
  { role: Role.ADMIN_FINANCE, label: '运营-财务', merchantId: 'demo-platform', desc: '分账/反向分账审批' },
  { role: Role.TAX_OFFICER, label: '税务专员（只读）', merchantId: 'demo-platform', desc: '合规档案核查' },
]

export function DemoLogin() {
  const nav = useNavigate()
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState('')

  async function login(opt: (typeof ROLE_OPTIONS)[number]) {
    setLoading(true)
    setErr('')
    try {
      const data = await api.post<{ token: string; identity: import('@ecom/shared').DemoIdentity }>(
        '/auth/demo-login',
        { role: opt.role, merchantId: opt.merchantId, operatorName: opt.label },
      )
      setToken(data.token, data.identity)
      // 按角色跳转默认首页
      const home =
        opt.role === Role.SELLER ? '/seller' :
        opt.role === Role.FACTORY ? '/factory' :
        '/admin'
      nav(home)
    } catch (e) {
      setErr((e as Error).message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ maxWidth: 480, margin: '60px auto', padding: 24 }}>
      <h1>数智化供销平台</h1>
      <hr style={{ margin: '16px 0' }} />
      <h3>Demo 登录（点击角色进入）</h3>
      <div style={{ display: 'grid', gap: 8, marginTop: 12 }}>
        {ROLE_OPTIONS.map((opt) => (
          <button
            key={opt.merchantId}
            onClick={() => login(opt)}
            disabled={loading}
            style={{
              padding: '12px 16px',
              textAlign: 'left',
              cursor: 'pointer',
              border: '1px solid #ddd',
              borderRadius: 6,
              background: '#fff',
            }}
          >
            <div style={{ fontWeight: 600 }}>{opt.label}</div>
            <div style={{ fontSize: 12, color: '#888' }}>{opt.desc}</div>
          </button>
        ))}
      </div>
      {err && <div style={{ color: 'red', marginTop: 12 }}>{err}</div>}

      <hr style={{ margin: '24px 0 12px', border: 'none', borderTop: '1px solid #eee' }} />
      <div style={{ fontSize: 13, color: '#666' }}>
        新商户？{' '}
        <a href="#/apply" style={{ color: '#2563eb' }}>
          提交入驻申请 →
        </a>
      </div>
    </div>
  )
}
